export default __webpack_public_path__ + "hero-xs-2815e23073882c0cafb732f4c145c6df.digested.webp";